var address = {};
module['exports'] = address;
address.city_root = require("./city_root");
address.city = require("./city");
address.default_country = require("./default_country");
address.postcode = require("./postcode");
address.country = require("./country");